export const ADMIN_THEMES_ANALYTICS_SOURCE = 'adminThemes';
